<template>
  <span :data-obscure="ObfuscateJSON" v-if="!obfuscationInit">
    <slot>{{ link.text }}</slot>
  </span>
  <ux-atoms-link v-bind="link" v-else>
    <slot>{{ link.text }}</slot>
  </ux-atoms-link>
</template>

<script lang="ts" setup>
import { LinkProps } from '../Link/Link.vue';

export type ObfuscateLinkProps = Omit<LinkProps, 'obfuscateLink'>;

interface Props {
  link: ObfuscateLinkProps;
}

const props = defineProps<Props>();

const { obfuscationInit } = useObfuscation();

const ObfuscateJSON = computed(() => {
  const json = {
    rel: props.link.rel,
    target: props.link.target,
    title: props.link.text,
    url: btoa(encodeURIComponent(props.link.href ?? ''))
  };

  return JSON.stringify(json);
});
</script>

<style lang="scss" scoped>
@use '../Link/Link.scss';
</style>
